import { render } from "./HeroBlog.vue?vue&type=template&id=7f15cfc7&scoped=true"
import script from "./HeroBlog.vue?vue&type=script&lang=js"
export * from "./HeroBlog.vue?vue&type=script&lang=js"

import "./HeroBlog.vue?vue&type=style&index=0&id=7f15cfc7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f15cfc7"]])

export default __exports__